import { useTranslation } from 'react-i18next';

/**
 * The frame around every screen in the sign-in flow.
 *
 * A single centred card rather than the dashboard's chrome: none of the
 * sidebar's navigation is reachable yet, and rendering it disabled would be a
 * worse answer than not rendering it.
 */
export interface AuthLayoutProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export function AuthLayout({ title, description, children, footer }: AuthLayoutProps) {
  const { t } = useTranslation();

  return (
    <div className="grid min-h-screen place-items-center bg-surface-alt px-4 py-10">
      <div className="w-full max-w-md">
        <p className="text-center text-body-sm font-semibold uppercase tracking-wide text-muted">
          {/* Latin, so `uppercase` is safe here — CLAUDE.md rule 3 is about
              Georgian, which has no uppercase. */}
          {'SJSU'}
        </p>
        <h1 className="mt-1 text-center text-h3 font-extrabold text-primary">
          {t('common.appName')}
        </h1>

        <div className="mt-8 rounded-panel bg-surface p-6 shadow-sm lg:p-8">
          <h2 className="text-h4 font-extrabold text-primary">{title}</h2>
          {description ? <p className="mt-2 text-body-sm text-secondary">{description}</p> : null}

          <div className="mt-6">{children}</div>
        </div>

        {footer ? <div className="mt-6 text-center text-body-sm">{footer}</div> : null}
      </div>
    </div>
  );
}
